import { Hand, Handshake } from "lucide-react";
import { Icon, type IconSize } from "@cntrl/ui";
import styles from "./ManagerModeMark.module.scss";

/**
 * The artist's Settings › Team manager mode as a small status icon beside their name on the roster (ART-353, PO
 * 2026-10-29): Hands on (a handshake: the artist hears what the manager hears and they run it together) or Hands off
 * (a raised hand: the manager is the only one hearing about holds and show requests). The server serves `managerMode`
 * only on a row reached through a MANAGEMENT link, so this renders for managers and nobody else.
 */
export function ManagerModeMark({ mode, size = 16, className }: { mode?: string | null; size?: IconSize; className?: string }) {
  if (mode !== "hands_on" && mode !== "hands_off") return null;
  const handsOff = mode === "hands_off";
  const label = handsOff
    ? "Hands off: you're the only one notified about holds and show requests"
    : "Hands on: the artist gets the same show notifications you do";
  return (
    <span className={[styles.mark, className].filter(Boolean).join(" ")} data-mode={mode} title={label}>
      <Icon icon={handsOff ? Hand : Handshake} size={size} label={label} />
    </span>
  );
}
